export var orange = {
    900: '#AB4510',
    800: '#EF6A00',
    700: '#F57C00',
    600: '#FB8B00',
    500: '#FF9700',
    400: '#FFA625',
    300: '#FFB64C',
    200: '#FFCB80',
    100: '#FFE0B2',
    50: '#FFF3E0',
};
//# sourceMappingURL=orange.js.map